import * as types from './mutation-types'
import api from '../../../api/thirdparty.js'

export const getActiveThirdPartyPartners = async ({ commit, dispatch }) => {
    try {
        var { data } = await api.getActiveThirdPartyPartners();
        commit(types.ACTIVE_TPP, data)
    } catch (e) {
        let msg = "There was an error getting the third party partners."
        dispatch('showError', msg, { root: true })
        throw msg;
    }
}

export const getAllThirdPartyPartners = async ({ commit, dispatch }) => {
    try {
        var { data } = await api.getAllThirdPartyPartners();
        commit(types.ALL_TPP, data)
    } catch (e) {
        let msg = "There was an error getting the third party partners."
        dispatch('showError', msg, { root: true })
        throw msg;
    }
}

export const setSelectedThirdPartyPartner = async ({ commit }, partner) => {
    commit(types.SET_SELECTED_THIRDPARTY_PARTNER, partner)
};

export const saveThirdPartyPartner = async ({ dispatch }, partner) => {
    // remove leading zeros from callCodeID
    let callcode = partner.callCodeID.toString().replace(/^0+(?=\d)/, '');

    // to handle the case where callCodeID is 0, it should be null in the db
    if (callcode === '0') {
        partner = { ...partner, callCodeID: null }
    }

    try {
        let { data } = await api.create(partner);
        if (data.status === 500) {
            throw new Error('Server error occurred');
        }
        let msg = {
            title: 'Created',
            message: 'Third Party Partner saved.',
            type: 'success'
        }
        dispatch("showNotification", msg);
        dispatch("getAllThirdPartyPartners");
        dispatch("getActiveThirdPartyPartners");
    } catch (e) {
        let msg = "DCB Call Code ID does not exist";
        dispatch("showError", msg, { root: true });
        throw err;
    }
};

export const updateThirdPartyPartner = async ({ dispatch }, partner) => {
    // remove leading zeros from callCodeID
    let callcode = partner.callCodeID.toString().replace(/^0+(?=\d)/, '');

    // to handle the case where callCodeID is 0, it should be null in the db
    if (callcode === '0') {
        partner = { ...partner, callCodeID: null }
    }
    
    try {
        let { data } = await api.update(partner);
        if (data.status === 500) {
            throw new Error('Server error occurred');
        }
        let msg = {
            title: 'Created',
            message: 'Third Party Partner saved.',
            type: 'success'
        }
        dispatch("showNotification", msg);
        dispatch("getAllThirdPartyPartners");
        dispatch("getActiveThirdPartyPartners");
    } catch (e) {
        let msg = "DCB Call Code ID does not exist";
        dispatch("showError", msg, { root: true });
        throw err;
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/thirdparty/actions.js